import { Navigate } from "react-router-dom";
import { Spinner } from "@vlab-corporation/design-system";
import { useAuthContext } from "./AuthProvider";
import type { ReactNode } from "react";

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { authState } = useAuthContext();

  if (authState.status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (authState.status === "unauthenticated") {
    return <Navigate to="/login" replace />;
  }

  // 강사 정체성은 studiomateStaffId(매핑) ?? instructorId(=userUid)로 결정되며,
  // instructorId는 강사 멤버십에 항상 존재한다. Studiomate 매핑 없이도 진입 허용.
  return <>{children}</>;
}
